import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { EmployeeActions } from './employee-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useEmployeeActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const actionMenuHelper = useActionMenuComposable();
  const validatePermission = CHECK_PERMISSIONS();
  const employeeActionMenuItems: ActionMenuItem[] = [
    {
        title:'Manage dependants', 
        icon:'groups',
        route:'/employees',
        validPermission: validatePermission.canReadEmployees(),
        action: EmployeeActions.ManageDependants,
    },
    {
        title:'Details', 
        icon:'info',
        route:'/employees',
        validPermission: validatePermission.canReadEmployees(),
        action: EmployeeActions.PageChange,
    },
    {
        title:'Deactivate',
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/employees',
        validPermission: validatePermission.canReadEmployees(),
        action: EmployeeActions.Toggled,
    },
  ];
  return{
    employeeActionMenuItems
  }
};